export enum EInvoiceState {
    NotDownloaded = 'NotDownloaded',
    Downloaded = 'Downloaded'
}
